import React, { useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ModalCerrarServicios.css';
import API_BASE_URL from '../config';

const moment = require('moment-timezone');

const ModalCerrarServicio = ({ servicio, onClose }) => {
  const [qrInput, setQrInput] = useState('');
  const [pulseraValida, setPulseraValida] = useState(false);
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState('');
  const token = useSelector((state) => state.auth.token);
  const user = JSON.parse(localStorage.getItem('user')) || {};

  const validarQR = (valor) => {
    if (!valor) return;

    
    if (valor === servicio.qr) {
      setPulseraValida(true);
      toast.success('QR validado correctamente.', { position: 'top-right', autoClose: 3000 });
    } else {
      toast.error('El QR escaneado no coincide con el servicio.', { position: 'top-right', autoClose: 3000 });
    }
  };

  const handleQRChange = (e) => {
    setQrInput(e.target.value);
  };
  
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === 'Tab') {
      e.preventDefault(); // Evita cambio de foco
      validarQR(qrInput);
    }
  };
  

  const handleConcluirServicio = async () => {
    setLoading(true);
    setMensaje('Concluyendo servicio...');
    try {
      const updates = {
        statusServicio: 'CONCLUIDO',
        horafin: moment().tz('America/Mexico_City').format('YYYY-MM-DD HH:mm:ss'),
        usuarioFin: user.noColaborador,
      };

      await axios.put(
        `${API_BASE_URL}api/servicios/${servicio.noServicio}`,
        updates,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );

      toast.success('Servicio concluido exitosamente', { position: 'top-right', autoClose: 3000 });
      setTimeout(() => {
        onClose();
        window.location.reload();
      }, 3000);
    } catch (error) {
      console.error('Error al concluir servicio:', error);
      setMensaje('Hubo un error al concluir el servicio.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay">
      <ToastContainer />
      <div className="modal">
        <h2>Concluir Servicio</h2>
        <div className="qr-section">
          <label>Escanea el QR del pase de abordar:</label>
          <input
  type="text"
  value={qrInput}
  onChange={handleQRChange}
  onKeyDown={handleKeyDown}
  className="form-control"
  autoFocus
/>

        </div>
        <button
          onClick={handleConcluirServicio}
          disabled={!pulseraValida || loading}
          className={`btn-concluir-servicio ${pulseraValida ? 'activo' : 'desactivado'}`}
        >
          {loading ? 'Concluyendo...' : 'Concluir Servicio'}
        </button>
        <button onClick={onClose} className="btn-cancelar">Cancelar</button>
      </div>
    </div>
  );
};

export default ModalCerrarServicio;
